declare namespace $ {

	type $mol_select__value_shm_hitalama_method_runtime_view_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['template'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_method_runtime_view_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['template_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_method_runtime_view_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['mock'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_method_runtime_view_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['mock_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $shm_hitalama_textarea__hint_shm_hitalama_method_runtime_view_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $shm_hitalama_textarea__sidebar_showed_shm_hitalama_method_runtime_view_6 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['sidebar_showed'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_method_runtime_view_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['source_text'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__spellcheck_shm_hitalama_method_runtime_view_8 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['spellcheck'] >
	>
	type $mol_page__title_shm_hitalama_method_runtime_view_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__head_shm_hitalama_method_runtime_view_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_hitalama_method_runtime_view_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_method_runtime_view_methods__selected_shm_hitalama_method_runtime_view_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['selected'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['selected'] >
	>
	type $shm_hitalama_method_runtime_view_methods__source_method_shm_hitalama_method_runtime_view_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['source_method'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['source_method'] >
	>
	type $shm_hitalama_method_runtime_view_methods__ids_shm_hitalama_method_runtime_view_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['method_ids'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['ids'] >
	>
	type $shm_hitalama_method_runtime_view_methods__method_title_shm_hitalama_method_runtime_view_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['method_title'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['method_title'] >
	>
	type $shm_hitalama_method_runtime_view_methods__method_view_shm_hitalama_method_runtime_view_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['method_view'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['method_view'] >
	>
	type $shm_hitalama_method_runtime_view_methods__run_shm_hitalama_method_runtime_view_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['method_run'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['run'] >
	>
	type $shm_hitalama_method_runtime_view_methods__focus_shm_hitalama_method_runtime_view_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['method_focus'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods['focus'] >
	>
	type $mol_check_box__checked_shm_hitalama_method_runtime_view_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['fullscreen'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_method_runtime_view_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__field_shm_hitalama_method_runtime_view_21 = $mol_type_enforce<
		({ 
			'title': string,
		})  & ReturnType< $mol_check_box['field'] >
		,
		ReturnType< $mol_check_box['field'] >
	>
	type $mol_check_box__Icon_shm_hitalama_method_runtime_view_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['Preview_fullscreen_icon'] >
		,
		ReturnType< $mol_check_box['Icon'] >
	>
	type $mol_view__sub_shm_hitalama_method_runtime_view_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['result_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_hitalama_method_runtime_view_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['preview_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__head_shm_hitalama_method_runtime_view_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_hitalama_method_runtime_view_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_textarea__value_shm_hitalama_method_runtime_view_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view['result_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	export class $shm_hitalama_method_runtime_view extends $mol_book2 {
		fullscreen( next?: boolean ): boolean
		template( next?: string ): string
		template_options( ): ({ 
			'_app': string,
			'_ba': string,
		}) 
		Template( ): $mol_select
		mock( next?: string ): string
		mock_options( ): Record<string, any>
		Mock( ): $mol_select
		source_text( next?: string ): string
		Source( ): $shm_hitalama_textarea
		Source_page( ): $mol_page
		selected( next?: string ): string
		source_method( next?: string ): string
		method_ids( ): readonly(any)[]
		method_view( id: any): boolean
		method_run( id: any, next?: any ): any
		method_focus( id: any, next?: boolean ): boolean
		Methods_page( ): $shm_hitalama_method_runtime_view_methods
		preview_title( ): string
		Preview_fullscreen_icon( ): $mol_icon_arrow_expand_all
		Preview_fullscreen( ): $mol_check_box
		result_sub( ): readonly(any)[]
		Result( ): $mol_view
		Preview_page( ): $mol_page
		result_text( ): string
		runtime( ): $shm_hitalama_method_runtime
		source( next?: string ): string
		selected_view( next?: string ): string
		result( next?: string ): string
		method_title( id: any): string
		attr( ): ({ 
			'shm_hitalama_method_runtime_view_fullscreen': ReturnType< $shm_hitalama_method_runtime_view['fullscreen'] >,
		})  & ReturnType< $mol_book2['attr'] >
		placeholders( ): readonly(any)[]
		pages( ): readonly(any)[]
		Result_text( ): $mol_textarea
	}
	
	type $mol_dimmer__needle_shm_hitalama_method_runtime_view_methods_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view_methods['menu_filter'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_dimmer__haystack_shm_hitalama_method_runtime_view_methods_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view_methods['method_title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $shm_hitalama_method_runtime_view_methods_item__method_view_shm_hitalama_method_runtime_view_methods_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view_methods['method_view'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods_item['method_view'] >
	>
	type $shm_hitalama_method_runtime_view_methods_item__sub_shm_hitalama_method_runtime_view_methods_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods_item['sub'] >
	>
	type $mol_check_box__checked_shm_hitalama_method_runtime_view_methods_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view_methods['focus'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_method_runtime_view_methods_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $shm_hitalama_method_runtime_view_methods_link__attr_shm_hitalama_method_runtime_view_methods_7 = $mol_type_enforce<
		({ 
			'mol_link_current': ReturnType< $shm_hitalama_method_runtime_view_methods['item_current'] >,
		})  & ReturnType< $shm_hitalama_method_runtime_view_methods_link['attr'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods_link['attr'] >
	>
	type $shm_hitalama_method_runtime_view_methods_link__arg_shm_hitalama_method_runtime_view_methods_8 = $mol_type_enforce<
		Record<string, any>
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods_link['arg'] >
	>
	type $shm_hitalama_method_runtime_view_methods_link__sub_shm_hitalama_method_runtime_view_methods_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view_methods['menu_link_content'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods_link['sub'] >
	>
	type $shm_hitalama_method_runtime_view_methods_link__click_shm_hitalama_method_runtime_view_methods_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_method_runtime_view_methods['run'] >
		,
		ReturnType< $shm_hitalama_method_runtime_view_methods_link['click'] >
	>
	export class $shm_hitalama_method_runtime_view_methods extends $mol_book2_catalog {
		method_view( id: any): boolean
		focus( id: any, next?: boolean ): boolean
		item_current( id: any): boolean
		Method_title( id: any): $mol_dimmer
		menu_link_content( id: any): readonly($mol_view_content)[]
		run( id: any, next?: any ): any
		menu_title( ): string
		selected( next?: string ): string
		source_method( next?: string ): string
		ids( ): readonly(string)[]
		method_title( id: any): string
		spread_ids( ): ReturnType< $shm_hitalama_method_runtime_view_methods['ids'] >
		spread_title( id: any): ReturnType< $shm_hitalama_method_runtime_view_methods['method_title'] >
		menu_filter_enabled( ): boolean
		placeholders( ): readonly(any)[]
		menu_item_content( id: any): readonly($mol_view)[]
		Method_item( id: any): $shm_hitalama_method_runtime_view_methods_item
		Method_focus( id: any): $mol_check_box
		Menu_link( id: any): $shm_hitalama_method_runtime_view_methods_link
	}
	
	export class $shm_hitalama_method_runtime_view_methods_link extends $mol_link {
	}
	
	export class $shm_hitalama_method_runtime_view_methods_item extends $mol_view {
		method_view( ): boolean
		attr( ): ({ 
			'shm_hitalama_method_runtime_view_method_view': ReturnType< $shm_hitalama_method_runtime_view_methods_item['method_view'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map